import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { INVENTORY_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";
import { useCurrentTrip } from "@/hooks";

export type TripItineraryLocation = {
  m_lat: string;
  m_lng: string;
  m_zoom_level?: number;
  country?: string;
  region?: string;
  city?: string;
  forceOverview?: boolean;
};

export type TripItinerary = {
  content: string;
  duration?: number | null;
  itinerary_type_id?: number | null;
  teaser?: string | null;
  title: string;
  type?: string | null;
  type_id?: number | null;
  location?: Array<TripItineraryLocation>;
  id: number;
};

export type Coords = {
  lat: number;
  lng: number;
  zoom: number;
};

type Result = Partial<{
  success: boolean;
  statusCode: number;
  response: Array<TripItinerary>;
}>;
type QueryError = {};

const useTripItinerariesQuery = (
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const { currentTrip } = useCurrentTrip();
  const tripId = currentTrip?.trip_id;
  const url = `${INVENTORY_ENDPOINT}/trips/${tripId}/itineraries`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tripId) throw new Error();
      return fetchWithAuth<Result>(url);
    },
    {
      ...options,
      enabled: !!tripId,
    }
  );
};
export default useTripItinerariesQuery;
